import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithCatalogProductDetailsHealthProvider, useCatalogProductDetailsHealth] = createComponentHealth('CatalogProductDetails');
